export default {
  namespaced: true,
  state: {
    showMenuStore: false,
    messages: [],
    breadcrumbs: []
  },
  getters: {
    getShowMenuStore(state) {
      return state.showMenuStore;
    },
    getMessages(state){
      return state.messages;
    },
    getBreadcrumbs(state){
      return state.breadcrumbs;
    }
  },
  mutations: {
    setShowMenuStore(state, showMenuStore) {
      state.showMenuStore = showMenuStore;
    },
    reportMessage(state,message){
      state.messages.push(message);
    },
    confirmMessage(state,message) {
      var indice = state.messages.indexOf(message);
      state.messages.splice(indice, 1);
    },
    setBreadcrumbs(state, breadcrumbs){
      state.breadcrumbs = breadcrumbs;
    }
  },
  actions: {
    borrarBreadcrumb:  function ({commit}){
      commit("setBreadcrumbs",[]);
    },
  }
}